import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Register from '@/components/Register'
import Login from '@/components/Login'
import ConfirmEmail from '@/components/ConfirmEmail'
import Reset from '@/components/Reset'
import ConfirmReset from '@/components/ConfirmReset'
import store from '@/store'

Vue.use(Router)

const needsAuthentication = (to, from, next) => {
  // Check if a token is present, else redirect to login
  if (store.state.auth.token) {
    next()
    return
  }
  next('/login/auth')
}

const tryAutoLogin = (to, from, next) => {
  // Only allow this route if no token is present (e.g. when someone navigates to login, they should be taken to home instead)
  if (!store.state.auth.token) {
    next()
    return
  }
  next('/home/account')
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home/:component?',
      name: 'Home',
      component: Home,
      props: true,
      beforeEnter: needsAuthentication
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      beforeEnter: tryAutoLogin
    },
    {
      path: '/login/:message?',
      name: 'Login',
      component: Login,
      props: true,
      beforeEnter: tryAutoLogin
    },
    {
      path: '/confirm-email/:nonce',
      name: 'ConfirmEmail',
      component: ConfirmEmail,
      props: true
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/reset/:uid/:token',
      name: 'ConfirmReset',
      component: ConfirmReset,
      props: true
    }
  ]
})

// Resolved before navigating to a component
router.beforeEach(function (to, from, next) {
  // Scroll to top of page after redirect
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js